import React from "react";

const ShipmentIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.8333 13.3334V5.00008C10.8333 4.53984 10.4602 4.16675 10 4.16675H3.33333C2.8731 4.16675 2.5 4.53984 2.5 5.00008V13.3334C2.5 13.7937 2.8731 14.1667 3.33333 14.1667H4.16667M10.8333 13.3334C10.8333 13.7937 10.4602 14.1667 10 14.1667H7.5M10.8333 13.3334L10.8333 6.66675C10.8333 6.20651 11.2064 5.83341 11.6667 5.83341H13.8215C14.0425 5.83341 14.2545 5.92121 14.4107 6.07749L17.2559 8.92267C17.4122 9.07895 17.5 9.29091 17.5 9.51193V13.3334C17.5 13.7937 17.1269 14.1667 16.6667 14.1667H15.8333M10.8333 13.3334C10.8333 13.7937 11.2064 14.1667 11.6667 14.1667H12.5M4.16667 14.1667C4.16667 15.0872 4.91286 15.8334 5.83333 15.8334C6.75381 15.8334 7.5 15.0872 7.5 14.1667M4.16667 14.1667C4.16667 13.2463 4.91286 12.5001 5.83333 12.5001C6.75381 12.5001 7.5 13.2463 7.5 14.1667M12.5 14.1667C12.5 15.0872 13.2462 15.8334 14.1667 15.8334C15.0871 15.8334 15.8333 15.0872 15.8333 14.1667M12.5 14.1667C12.5 13.2463 13.2462 12.5001 14.1667 12.5001C15.0871 12.5001 15.8333 13.2463 15.8333 14.1667"
      stroke="#979393ff"
      stroke-width="2"
    />
  </svg>
);

export default ShipmentIconSvg;
